// @flow

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Selectors
import clickedComment$ from '../selectors/clickedComment'
import { crops$ } from 'fc-model-crops'
import { currentUserUnits$ } from 'hfty-users'

// actions
import {
  fetchComments,
} from 'hfty-comments'

// type
import type {
  Comment,
} from 'hfty-model-comments/types'


// State -> Props
type Props = {
  comment: Comment,
}

function mapStateToProps (state: Object): Props {
  return {
    comment: clickedComment$(state),
    crops: crops$(state),
    currentUserUnits: currentUserUnits$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    fetchComments: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      fetchComments: fetchComments,
    }, dispatch),
  }
}

// Export
export default connect(mapStateToProps, mapDispatchToProps)
